import React from 'react'
import { HashRouter } from 'react-router-dom'
import {Input, Button, message, Modal} from 'antd'
import './login.css'
import axios from '../interceptor/http'
import {UserOutlined, LockOutlined} from '@ant-design/icons'
import AppService from "../AppService";
const router = new HashRouter();

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                password: "",
                username: ""
            },
            errorMsg: ""
        };
    }
    componentDidMount() {}
    chandelLogin = () => {
        let secret = localStorage.getItem('uuid');
        if (!secret || secret === 'undefined' || secret === 'null') {
            window.electronAPI.getMachineId().then(data => {
                if (data.hashedId && data.hashedId !== 'undefined' && data.hashedId !== 'null') {
                    localStorage.setItem('uuid', data.hashedId);
                    this.getToken(data.hashedId, 'electron');
                } else {
                    Modal.error({content: '获取设备码失败，请点击登录重新获取！'})
                }
            })
        } else {
            this.getToken(secret, 'local');
        }
    }
    getToken = (secret, deviceUrl) => {
        axios({
            url: '/api/oauth/login',
            method: 'post',
            data: "password=" + this.state.user.password + "&username=" + this.state.user.username + "&deviceId=" + secret + "&deviceIdSource=" + deviceUrl
                + "&grant_type=password&auth_type=password&clientId=storeClient&secret=39ojdofouer3435MMOP8930535kdlg3L&scope=read",
            header: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code && res.data.code !== "1000") {
                message.success(res.data.message, 1)
            } else {
                let token = res.data.data.accessToken;
                localStorage.setItem("storeToken", token);
                localStorage.setItem('currentUserAllInfo', JSON.stringify(res.data.data))
                this.props.history.push('/dataPane');
            }
        }).catch(err => {
            console.log("登录错误", err)
            message.warning('网络请求出错')
            this.setState({
                errorMsg: err.data.message
            })
        })
    };
    handleChange = (event) => {
        const target = event.target;
        let user = Object.assign({}, this.state.user, { [target.name]: target.value });
        this.setState({ user: user });
    };
    render() {
        return (
            <>
                <div className="loginCon">
                    <div className="loginBox">
                        <div className="dis_center_r" style={{width: '60%', height: '100%', flexDirection: 'column'}}>
                            <div className="loginTxt">让传统产品焕发全新生命力</div>
                            <div className="loginTxt2">智能化数据采集</div>
                            <img style={{width: '80%'}} src={require('../assets/loginLeft.png')}/>
                            <div className="dis_center_r fontLogin marginT_20" style={{width: '100%'}}>
                                <div className="flex_1_center">
                                    <img style={{width: '60px'}} src={require('../assets/loginIcon1.png')}/>
                                    <label>智能化采集</label>
                                </div>
                                <div className="flex_1_center">
                                    <img style={{width: '60px'}} src={require('../assets/loginIcon2.png')}/>
                                    <label>数字化展示</label>
                                </div>
                                <div className="flex_1_center">
                                    <img style={{width: '60px'}} src={require('../assets/loginIcon3.png')}/>
                                    <label>操作迅速简洁</label>
                                </div>
                            </div>
                        </div>
                        <div className="loginCntAccount">
                            <div className="logo_img" style={{width: '100%'}}>
                                <p style={{ width: '100%',fontSize: '36px', marginBottom: '20px', color: '#2b2b2b', fontWeight: 'bolder' }}>您好，</p>
                                <p style={{ width: '100%',fontSize: '20px',  color: '#2b2b2b', fontWeight: 600, letterSpacing: '4px' }}>欢迎使用发动机诊断系统</p>
                            </div>
                            <>
                                <Input addonBefore={<UserOutlined />} placeholder="用户名" onChange={this.handleChange} name="username" value={this.state.user.username} />
                                <Input type="password" addonBefore={<LockOutlined />} onChange={this.handleChange} name="password" value={this.state.user.password} placeholder="密码" />
                                {/*<div className='errorMsg'><span style={{ color: '#fa541c' }}>{this.state.errorMsg}</span><Link to='/register'><span>忘记密码？</span></Link></div>*/}
                                <Button onClick={this.chandelLogin} type="primary" style={{ width: '100%', marginTop: '20px',borderRadius: "100px", height: '44px' }}>登录</Button>
                            </>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    changeKey(key) {
        console.log(`changeKey`, key)
    }


}
